import React, { useState, useEffect } from "react";
import { useNavigate, useLocation, json } from "react-router-dom";
import axios from "axios";
import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Button,
  } from "@mui/material";

function ManageOrderStatus() {
    const navigate = useNavigate();
    const [error, setError] = useState("");
    const [status, setStatus] = useState([]);
    const [currentStatus, setCurrentStatus] = useState([]);
    const [terminationStatus, setTerminationStatus] = useState(0);
    const [openConfirm, setOpenConfirm] = useState(false);
    const [openInputSuccess, setOpenInputSuccess] = useState(false);
    const [openInputFail, setOpenInputFail] = useState(false);
    const [notes, setNotes] = useState('');
    const [internalEmail, setInternalEmail] = useState("");
    
    const resource = 'operation/manage-order-status';

   useEffect(() => {
      // Retrieve the token from local storage
      const storedToken = localStorage.getItem("token");
  
      // Fetch internal data using the token
      const fetchInternalData = async () => {
        try {
          const response = await fetch(
            `https://lbhaw84n6b.execute-api.ap-southeast-3.amazonaws.com/xcp/auth/find-by-token?token=${storedToken}`,
            {
              method: "GET",
              headers: {
                "Content-Type": "application/json",
              },
            }
          );
  
          const data = await response.json();
  
          if (!response.ok) {
            setError(data.message || "Failed to fetch internal data");
            throw new Error(data.message || "Failed to fetch internal data");
          }
  
          setInternalEmail(data[0].xcp_internal_email);
        } catch (error) {
          console.error("Fetch Error:", error.message);
          setError("Fetch Error: " + error.message);
        }
      };
  
      fetchInternalData();
    }, []);

    useEffect(() => {
        const storedToken = localStorage.getItem("token");

        const checkSessionToken = async () => {
        try {
            const response = await fetch(
            `https://lbhaw84n6b.execute-api.ap-southeast-3.amazonaws.com/xcp/auth/check-session?token=${storedToken}&resource=${resource}`,
            {
                method: "GET",
                headers: {
                "Content-Type": "application/json",
                },
            }
            );

            if (!response.ok) {
            setError(data.message || "Failed to fetch session token data");
            throw new Error(data.message || "Failed to fetch session token data");
            }

            // Parse response text as a boolean value
            const text = await response.text();
            const data = text === "true";

            if (data) {
            } else {
            window.alert("Session is invalid");
            navigate("/login");
            }
        } catch (error) {
            console.error("Fetch Error:", error.message);
            setError("Fetch Error: " + error.message);
        }
        };

    checkSessionToken();
  }, []);

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

const [statusLoaded, setStatusLoaded] = useState(false);

useEffect(() => {
  const fetchData = async () => {
    await loadStatus();
    setStatusLoaded(true);
  };
  fetchData();
}, []);

useEffect(() => {
  if (statusLoaded) {
    const terminationId = searchParams.get("terminationId");
    if (terminationId) {
      findStatusByOrderId(terminationId);
    }
  }
}, [statusLoaded]);

  const loadStatus = async () => {
    try {
    const result = await axios.get("https://lbhaw84n6b.execute-api.ap-southeast-3.amazonaws.com/xcp/operation/find-termination-status");
    const data = result.data.body;  

    setStatus(data);
  } catch (error) {
    console.error("Submission Error:", error.message);
    setError("Submission Error: " + error.message);
  }
  };

  const findStatusByOrderId = async (terminationId) => {
    try{
    const response = await axios.get(`https://lbhaw84n6b.execute-api.ap-southeast-3.amazonaws.com/xcp/operation/find-status-by-termination-id?terminationId=${terminationId}`);
    
      setCurrentStatus(response.data[0]);
      setTerminationStatus(response.data[0].xcp_termination_status)
    } catch (error) {
      console.error("Submission Error:", error.message);
      setError("Submission Error: " + error.message);
    }
  };

  function getLocalDate() {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0'); // Bulan dimulai dari 0
    const day = String(now.getDate()).padStart(2, '0');
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    const seconds = String(now.getSeconds()).padStart(2, '0');

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
}

  const handleSubmit = async (event) => {
    event.preventDefault();

     const localDateNow = getLocalDate();

      const formData = {
        newTerminationStatusId: terminationStatus,
        terminationId: currentStatus.xcp_termination_id,
        notes: notes,
        emailOperation: internalEmail,
        manageTerminationDate: localDateNow,
      };
      
      try {
        const response = await fetch(
          "https://lbhaw84n6b.execute-api.ap-southeast-3.amazonaws.com/xcp/operation/manage-termination-status",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(formData),
          }
        );

        const data = await response.json();
        const responseBody = JSON.parse(data.body);
        if (!response.ok) {
          setError(data.message || "Failed to submit form");
          throw new Error(data.message || "Failed to submit form");
        }

        const { message } = responseBody;
        if (message == "success") {
          setOpenConfirm(false)
          setOpenInputSuccess(true)
        } else {
          setOpenConfirm(false)
          setOpenInputFail(true)
        }
      } catch (error) {
        console.error("Submission Error:", error.message);
        setError("Submission Error: " + error.message);
      }
  };

  const handleClose = () => {
    setOpenConfirm(false);
    setOpenInputFail(false)
  };

  const handleConfirmation = async (event) => {
    event.preventDefault();
    if(terminationStatus == currentStatus.xcp_termination_status) {
      // window.scrollTo(0, 0);
      setError("The selected Termination Status is still the same as the previous Termination Status");
      
      // return;
    } else {   
    setOpenConfirm(true);
    }
    
  };

  function inputSuccess(){
    navigate("/operation/termination-list")
  }

  return (
    <div className="container-order-input">
      <h1>Cross Connect Manage Termination Status</h1>
      {error && <p className="error-message">{error}</p>}  
      <div className="box-two-part">
       
        <div className="order-information-operation">
        <div className='title-operation-1'>                            
                <h5>Termination Information</h5>  
            </div> 
              <div className="textbox-gray">
                    <label htmlFor="picName">Termination Id</label>
                    <input type="text" placeholder={currentStatus.xcp_termination_id} disabled/>
                </div>            
                <div className="textbox-gray">
                    <label htmlFor="requestor">Requestor</label>
                    <input type="text" placeholder={currentStatus.company_name} disabled/>
                </div>           
                <div className="textbox-gray">
                    <label htmlFor="picName">Existing Termination Status</label>
                    <input type="text" placeholder={currentStatus.xcp_termination_status_name} disabled/>
                </div>
            </div>

      <div className="form-operation">
        <form onSubmit={handleConfirmation}>
          <div className="title-operation">
            <h5>Select Termination Status</h5>                 
          </div>
          <table className="table table-bordered">
            <thead>
              <tr>
              <th scope="col">Select</th>
                <th scope="col">Termination Status</th>
                <th scope="col">Description</th>
              </tr>
            </thead>
                <tbody>
                {status.map((item) => {
                return (
                    <tr key={item.xcp_termination_status_id}>
                        <td>
                        <input
                        type="radio"
                        name="connect"
                        id={`connect-${item.termination_status_id}`}
                        value={item.xcp_termination_status_id}
                        checked={terminationStatus === item.xcp_termination_status_id}
                        onChange={(e) => setTerminationStatus(parseInt(e.target.value))}
                        disabled={item.xcp_termination_status_id > currentStatus.xcp_termination_status &&
                            item.xcp_termination_status_code !== "XCPTTS-098"}
                        required
                        />
                        </td>
                        <td>
                        <div >
                        
                        <label>{item.xcp_termination_status_name}</label>
                    </div>
                    </td>                         
                        <td>{item.xcp_termination_status_desc}</td>  
                    </tr>
                );
                })}
            </tbody>
          </table>     
          <div className="note-operation"> 
            <div className="textbox">
                <label htmlFor="Note">Note</label>
                <textarea
                value={notes} 
                onChange={(e) => setNotes(e.target.value)}
                placeholder='Note'      
                style={{ height: '110px' }}   
                required               
            ></textarea>  
            </div> 
          </div> 

          <input
              type="submit"
              className="btn-submit-operation"
              value="Submit"
            />
           
      </form>
    </div>
  </div>
      <Dialog open={openConfirm}>
          <DialogTitle>{"Are you sure you want to change the order status for this order?"}</DialogTitle>
              <DialogContent>
                  <DialogContentText>
                      Clicking "Yes" will  change the order status for this order.
                  </DialogContentText>
              </DialogContent>
          <DialogActions>
              <Button onClick={handleClose} color="primary">
                  No
              </Button>
              <Button onClick={handleSubmit} color="primary" autoFocus>
                  Yes
              </Button>
          </DialogActions>
        </Dialog> 
        <Dialog open={openInputSuccess}>
          <DialogTitle>{"Manage Order Change order status successfully"}</DialogTitle>
          <DialogActions>
            <Button onClick={inputSuccess} color="primary" autoFocus>
              Ok
            </Button>
          </DialogActions>
      </Dialog>
      <Dialog open={openInputFail}>
        <DialogTitle>{"Manage Order failed"}</DialogTitle>
        <DialogActions>
          <Button onClick={handleClose} color="primary" autoFocus>
            Ok
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default ManageOrderStatus;
